import { Pinia, Store } from 'pinia-class-component';
import { GpsPositionUiClient, GpsPosDto } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'GpsPositionStore',
  name: 'GpsPositionStore',
})
export default class GpsPositionStore extends Pinia {
  private readonly gpsPositionApi = initClient(GpsPositionUiClient);

  //data
  private _loadingPromise: Promise<GpsPosDto[]> | null = null;
  private _gpsLastPositions: GpsPosDto[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get gpsLastPositions(): GpsPosDto[] {
    return this._gpsLastPositions;
  }

  //actions
  clear(): void {
    this._gpsLastPositions.splice(0);
  }

  private setGpsLastPositions(gpsTrackers: GpsPosDto[]): void {
    this._gpsLastPositions.splice(0);
    this._gpsLastPositions.push(...gpsTrackers);
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.gpsPositionApi.last();
      const gpsLastPositions = await this._loadingPromise;
      this.setGpsLastPositions(gpsLastPositions);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._gpsLastPositions.length > 0) {
      return;
    }
    return await this.reload();
  }
}